import {addPaymentOptions} from '../payment-actions';

const addAdyenV2OptionsToState = adyenV2Options => (dispatch) => {
  dispatch(addPaymentOptions(adyenV2Options));
};

export default addAdyenV2OptionsToState;
